"use strict";

exports.__esModule = true;
exports.iconPropTypes = void 0;

var _propTypes = require("prop-types");

var iconPropTypes = {
  children: _propTypes.node,
  color: _propTypes.string,
  rtl: _propTypes.bool,
  size: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  title: _propTypes.string
};
exports.iconPropTypes = iconPropTypes;